import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  deleteButton: {
    fontSize: 18,
    fontWeight: 400,
    marginTop: 25,
    padding: '10px 30px',
  },
}));
